
import React, { useState } from 'react';
import styles               from './navigation.module.css';
import { Link, useNavigate } from 'react-router-dom';


//---------------------------------------------------------
//  Function
//---------------------------------------------------------

export const Navigation = () =>
{
  
    const navigate            = useNavigate();
    const [num, setNum]       = useState(0);
    const [kum, setkum]       = useState(0);
    
    const overviewMenu = () => 
    {
        const newNum = (num + 1) % 5;
        setNum(newNum);
        navigate("/overview", { state: { location: newNum, unique: Date.now() }, });
    }
      
    const productsMenu = () =>
    {
        const newkum = (kum + 1) % 5;
        setkum(newkum);
        navigate("/products", { state: { location: newkum, unique: Date.now() }, });
    }
   
    const toTop = () => {window.scrollTo({ top: 0, left: 0, behavior: "smooth" })};


                                                                
    //----------------------------------------------------------------
    //  Render for Desktop (small devices are in App.jsx)
    //----------------------------------------------------------------
    const renderData = () => 
    (
        <div> 
            <div className = {styles.navigation} >
                <p className= {styles.button}  onClick={() => toTop( 'home')} >         <Link to = "/" style={{fontWeight: "500"}} >  Home            </Link></p>

                <p className= {styles.button}  onClick={() => toTop( 'overview')} >     <button className={styles.navAction} type="button" onClick={overviewMenu}>Overview</button></p>
                <p className= {styles.button}  onClick={() => toTop( 'products')} >     <button className={styles.navAction} type="button" onClick={productsMenu}>Products</button></p>

                <p className= {styles.button}  onClick={() => toTop( 'story')} >        <Link to = "/story"        style={{fontWeight: "500"}}>  Story           </Link></p>                    
                <p className= {styles.button}  onClick={() => toTop( 'investors')} >    <Link to = "/investors"    style={{fontWeight: "500"}}>  Investors       </Link></p>
                <p className= {styles.button}  onClick={() => toTop( 'publications')}>  <Link to = "/publications" style={{fontWeight: "500"}}>  Publications     </Link></p>                        
                <p className= {styles.button}  onClick={() => toTop( 'contact')} >      <Link to = "/contact"      style={{fontWeight: "500"}}>  Contact         </Link></p>
                <p className= {styles.button}  onClick={() => toTop( 'about')} >        <Link to = "/about"        style={{fontWeight: "500"}}>  About           </Link></p>
            </div>

            <br/>

            </div>        
    )      
       
    return  (renderData())

}

